import React from "react";
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import { pxToRem } from "../../utils/editor.ts";

interface FeedbackSuccessProps {
  ticket?: string;
  email?: string;
  onBack: () => void;
}

const FeedbackSuccess: React.FC<FeedbackSuccessProps> = ({ ticket, email, onBack }) => {
  return (
    <Box
      w="full"
      maxW={pxToRem(998)}
      mx="auto"
      borderRadius={pxToRem(20)}
      pt={pxToRem(40)}
      pb={pxToRem(40)}
      paddingX={pxToRem(30)}
    >
      <VStack spacing={pxToRem(16)} textAlign="center" alignItems="center">
        <Box
          w={pxToRem(88)}
          h={pxToRem(88)}
          bg="#22C55E"
          borderRadius="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          boxShadow={`0 ${pxToRem(4)} ${pxToRem(20)} rgba(34, 197, 94, 0.3)`}
        >
          <CheckIcon color="white" fontSize={pxToRem(44)} />
        </Box>
        <Heading as="h2" fontSize={pxToRem(28)} fontWeight="bold" color="gray.800">
          Thank You for Your Submission!
        </Heading>
        <Text fontSize={pxToRem(18)} color="gray.600" m={0}>
          We've received your question and will get back to you soon.
        </Text>

        {/* Ticket Card */}
        <Box
          w="full"
          maxW={pxToRem(740)}
          bg="#FFFFFF"
          border={`1px solid #D3D7E2`}
          borderRadius={pxToRem(16)}
          p={pxToRem(24)}
        >
          <Text fontSize={pxToRem(20)} fontWeight="700" color="#333" m={0}>
            Your Support Ticket
          </Text>
          <Box
            display="inline-block"
            mt={pxToRem(12)}
            bg="#DFE8F7"
            px={pxToRem(24)}
            py={pxToRem(10)}
            borderRadius={pxToRem(12)}
          >
            <Text m={0} fontSize={pxToRem(20)} fontWeight="700" letterSpacing={pxToRem(2)} color="#333">
              {ticket || "XXX-XXXX-XXX"}
            </Text>
          </Box>
        </Box>

        {/* Email Card */}
        <Box
          w="full"
          maxW={pxToRem(740)}
          bg="#FFFFFF"
          border={`1px solid #D3D7E2`}
          borderRadius={pxToRem(16)}
          p={pxToRem(24)}
        >
          <Text fontSize={pxToRem(20)} fontWeight="700" color="#333" m={0}>
            Email Confirmation Sent
          </Text>
          <Text fontSize={pxToRem(16)} color="#666" mt={pxToRem(6)}>
            We've Sent a confirmation email to
          </Text>
          <Text fontSize={pxToRem(18)} color="#1D8AFF" fontWeight="700" mt={pxToRem(6)}>
            {email || "XXX@XXmail.com"}
          </Text>
          <Text fontSize={pxToRem(12)} color="#8E9ABC" mt={pxToRem(6)}>
            The email contains your ticket number and a summary of your question and request. If you don't see it in your inbox please check your spam folder.
          </Text>
        </Box>

        <Button
          width={pxToRem(160)}
          h={pxToRem(48)}
          onClick={onBack}
          color="white"
          size="lg"
          bg={'#1D8AFF'}
          borderRadius="12px"
          _hover={{ bg: 'blue.600' }}
          _active={{ bg: 'blue.700' }}
          py={6}
          fontSize="md"
          fontWeight="medium"
          float={'right'}
          variant={'solid'}
          colorScheme='brand'
        >
          Back to support
        </Button>
      </VStack>
    </Box>
  );
};

export default FeedbackSuccess;